import Pill from './Pill.style'

export default Pill
